import React, { useRef, useState } from "react";
import RoomTour, { SectionHeading, IslandMarquee, SECTION_SUB } from "./island/RoomTour";
import IslandExplorer from "./island/IslandExplorer";
import DayPlanner from "./island/DayPlanner";

export default function Experiences() {
    const [saved, setSaved] = useState([]);
    const explorerRef = useRef(null);
    const plannerRef = useRef(null);

    const toggle = (activity) => {
        setSaved((prev) => prev.some((s) => s.id === activity.id)
            ? prev.filter((s) => s.id !== activity.id)
            : [...prev, activity]);
    };

    const scrollTo = (ref) => {
        const el = ref.current;
        if (!el) return;
        if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80, duration: 1.2 });
        else el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <section id="experiences" className="py-24 lg:py-32 bg-[#FAF8F5] overflow-hidden" data-testid="experiences-section">
            <div className="max-w-7xl mx-auto px-5 lg:px-8">
                <SectionHeading eyebrow="Your island, your way" sub={SECTION_SUB} />
                <IslandMarquee />
                <RoomTour onNext={() => scrollTo(explorerRef)} />
                <div ref={explorerRef} className="mt-20 lg:mt-28 scroll-mt-24">
                    <IslandExplorer saved={saved} toggle={toggle} />
                </div>
                <div ref={plannerRef} className="mt-20 lg:mt-28 scroll-mt-24">
                    <DayPlanner saved={saved} toggle={toggle} clearSaved={() => setSaved([])} />
                </div>
            </div>
        </section>
    );
}
